import React, { Fragment, useEffect } from "react";
import axios from "axios";
import { EuiButton, EuiEmptyPrompt } from "@elastic/eui";

export const NiiApplicationComplete: React.FC = () => {
  const payload = {
    recipient: localStorage.getItem("recipient"),
    greeting: "0762432603",
    recipeintsName: localStorage.getItem("recipeintsName"),
    subject: "something",
    message: "something",
  };
  useEffect(() => {
    axios.post("https://ntbc-mailer.herokuapp.com/send-email", payload);
  }, [payload]);
  return (
    <div>
      <EuiEmptyPrompt
        iconType="editorStrike"
        title={<h2>Your Application has be Submitted</h2>}
        body={
          <Fragment>
            <p>Thank you for submitting your application.</p>
            <p>
              For further queries, call, text, or whatsapp any one of these
              numbers: +260977622191, +260966750787 and +260979377422.
            </p>
          </Fragment>
        }
        actions={
          <EuiButton
            color="primary"
            fill
            onClick={() => (window.location.href = "https://ntbc.co.zm")}
          >
            Continue
          </EuiButton>
        }
      />
    </div>
  );
};
